import React, { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface ITextEditorProps {
    state?: string;
    hasError?: boolean;
    changeTextFieldHandler?: (value: string) => void;
    classes?: string;
    placeholder?: string;
    disabled?: boolean;
}

export default function TextEditor({
    placeholder,
    changeTextFieldHandler,
    state,
    hasError = false,
    classes,
    disabled = false,
}: ITextEditorProps) {
    const quillRef = useRef<ReactQuill>(null);

    useEffect(() => {
        const editor = quillRef.current?.editor;
        if (editor) {
            const editorNode = quillRef.current?.editor?.root;
            if (editorNode) {
                editorNode.setAttribute('translate', 'no');
                editorNode.classList.add('notranslate');
            }
        }
    }, []);

    const modules = {
        toolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }], ['link']],
    };

    return (
        <ReactQuill
            ref={quillRef}
            theme="snow"
            className={`${classes} ${hasError ? 'border-danger' : ''}`}
            value={state}
            modules={modules}
            placeholder={placeholder}
            readOnly={disabled}
            onChange={changeTextFieldHandler}
        />
    );
}
